import React, { useState, useEffect } from "react";
import car1 from "../../assets/assets/images/home_images/home_grid1.png";
import TextInput from "../fields/TextInput";
import { BiEdit } from "react-icons/bi";
import TimeandDate from "../fields/TimeandDate";
import { Link } from "react-router-dom";
import { MdDoubleArrow, MdPerson, MdPersonOutline } from "react-icons/md";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Switch,
  TextField,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import { FaMusic, FaTrashAlt } from "react-icons/fa";
import { PiDotOutlineFill } from "react-icons/pi";
import { RxDotFilled } from "react-icons/rx";
import { GrStar } from "react-icons/gr";
import { TbAirConditioning, TbManualGearbox } from "react-icons/tb";
import { HiColorSwatch, HiTrash } from "react-icons/hi";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { LuAirVent } from "react-icons/lu";
import { GrManual } from "react-icons/gr";
import { IoPerson } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import {
  bookCar,
  checkBookingValidation,
  cleanBookingData,
  clearBookCarData,
  setBookingAmount,
  setBookingData,
  setBookingDays,
  setWithDriver,
} from "../../redux/Slice/bookingSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import { Rating } from "react-simple-star-rating";
import Rating from "@mui/material/Rating";

import Swal from "sweetalert2";
const Index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const bookingInfo = useSelector((state) => state?.booking?.bookingInfo);
  const { personalDetailsData } = useSelector((state) => state?.booking);
  const authData  = useSelector((state) => state?.auth?.userDetail);
  const document = useSelector((state) => state?.booking?.documentsData);
  const { bookCarData, bookingAmount, bookingDays } = useSelector(
    (state) => state?.booking
  );
  // const personalDetailsData = useSelector(
  //   (state) => state?.booking?.personalDetailsData
  // );
  const getCartData = useSelector((state) => state?.car?.getCartData);
  // console.log(process.env.REACT_APP_LENCO_SECRET_KEY,8888888)
  // const bookCarStatus = useSelector((state) => state?.booking?.bookCarStatus);
  // const document = useSelector((state) => state?.booking?.documentsData);
  // const bookingImageObj = useSelector(
  //   (state) => state?.booking?.bookingImageObj
  // );
  // const bookingvalidationResponse = useSelector(
  //   (state) => state?.booking?.bookingvalidationResponse
  // );
  const rent = useSelector((state) => state?.booking?.rent);
  const carId = useSelector((state) => state?.booking?.carId);
  const withDriver = useSelector((state) => state?.booking?.withDriver);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  // const bookCarData = useSelector((state) => state?.booking?.bookCarData);
  const [edit, setEdit] = useState(false);
  const [checked, setChecked] = useState(withDriver);
  const [base64Data, setBase64Data] = useState({});
  const [isSubmitted, setIsSubmiited] = useState(false);
  const [errMsg, setErrMsg] = useState();
  const [info, setInfo] = useState({
    // pickAddress: "264 Royal Ln. Mesa, New Jersey 45453",
    // returnAddress: "264 Royal Ln. Mesa, New Jersey 45453",
    // PickupDate: "11/12/2024 02:34 am",
    // returnDate: "12/12/2024 02:34 am",
    PickupDate: bookingInfo?.pickUp,
    returnDate: bookingInfo?.dropOff,
    userToggle: bookingInfo?.userToggle,
  });
  const calculateDifference = (start, end) => {
    const differenceInMilliseconds = Math.abs(end - start);
    return Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));
  };
  // React.useEffect(() => {
  //   console.log(dayjs(bookingInfoData?.pickUp).isSame(dayjs(), "day"));
  //   if (dayjs(bookingInfoData?.pickUp).isSame(dayjs(), "day")) {
  //     const interval = setInterval(() => {
  //       const newPickupDate = dayjs();
  //       // .add(1, "minute");
  //       setBookingInfo((prevBookingInfo) => ({
  //         ...prevBookingInfo,
  //         pickupDate: newPickupDate,
  //       }));
  //     }, 1000 * 1); // Update every second
  //     return () => clearInterval(interval);
  //   }
  // }, [bookingInfoData]);

  const [differenceInDays, setDifferenceInDays] = useState(null);
  const [totalAmount, setTotalAmount] = useState(null);

  function findItemById(array, id) {
    return array.find((item) => item?._id === id);
  }
  const pageData = getCartData && findItemById(getCartData?.data, carId);

  useEffect(() => {
    if (!loginDetail) {
      navigate("/login");
    }
    // setChecked(pageData?.withDriver);
    // dispatch(setWithDriver(pageData?.withDriver));
  }, [pageData]);
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString();
  // console.log(123, formattedDate); // Outputs current UTC time in ISO 8601 format
  // console.log("dayjs()", dayjs(formattedDate));
  // console.log("drop", dayjs(bookingInfo?.dropOff));
  useEffect(() => {
    const daysDifference = calculateDifference(
      dayjs(bookingInfo?.pickUp),
      dayjs(bookingInfo?.dropOff)
    );
    setDifferenceInDays(daysDifference);
    if (bookingDays !== daysDifference)
      dispatch(setBookingDays(daysDifference));
    return () => {
      if (bookCarData && Array.isArray(bookCarData) && bookCarData?.length)
        dispatch(clearBookCarData());
    };
  }, [info, checked, edit]);
  // console.log("pageData?.withDriver", pageData?.withDriver);
  useEffect(() => {
    let rs = rent?.carRent + (checked ? +rent?.driverRent : 0);

    setTotalAmount(rs * differenceInDays);
    // console.log(145, bookingAmount);
    if (bookingAmount !== rs * differenceInDays)
      dispatch(setBookingAmount(rs * differenceInDays));
  }, [info, edit, differenceInDays, checked]);

  useEffect(() => {
    console.log("info", info);
    dispatch(
      setBookingData({
        pickUp: info.PickupDate,
        dropOff: info.returnDate,
        userToggle: info.userToggle,
      })
    );
  }, [info]);
  const [userInteraction, setUserInteraction] = useState(false);
  let interval;
  useEffect(() => {
    const checkAndUpdateTime = () => {
      const currentDate = dayjs();
      const pickupDate = dayjs(info.PickupDate);
      // console.log(pickupDate);
      // console.log(
      //   155,
      //   pickupDate.isBefore(currentDate, "minute"),
      //   pickupDate.isSame(currentDate, "minute"),
      //   pickupDate.isBefore(currentDate, "second")
      // );

      if (pickupDate.isSame(currentDate, "day")) {
        if (
          pickupDate.isBefore(currentDate, "minute") ||
          (pickupDate.isSame(currentDate, "minute") &&
            pickupDate.isBefore(currentDate, "second"))
        ) {
          // Check if pickupDate is less than currentDate
          if (
            info.PickupDate &&
            dayjs(info.PickupDate).isSame(currentDate, "day")
          ) {
            if (dayjs(info.PickupDate).isBefore(currentDate)) {
              setUserInteraction(false);
            }
          }
          // If the past time occurs, set userInteraction to false
          if (!userInteraction) {
            // console.log("Condition met, updating booking info");
            let date = new Date().toISOString();
            setInfo((prevBookingInfo) => ({
              ...prevBookingInfo,
              PickupDate: date,
            }));
          }
        }
      }
    };

    if (dayjs(info.PickupDate).isSame(dayjs(), "day")) {
      interval = setInterval(checkAndUpdateTime, 1000); // Check every second
    }

    return () => clearInterval(interval);
  }, [bookingInfo, userInteraction]);
  // function to change driver
  const handleChange = (event) => {
    setChecked(event.target.checked);
    dispatch(setWithDriver(event.target.checked));
  };

  const handleEdit = () => {
    setEdit(!edit);
  };
  console.log("document", document);

  useEffect(() => {
    setBase64Data({
      idFront: base64StringToSyntheticFile(document?.idFront),
      licenceFront: base64StringToSyntheticFile(document?.licence),
    });
  }, [document]);
  // useEffect(() => {
  //   if (bookCarData?.data?.success === true) {
  //     dispatch(cleanBookingData());
  //   }
  // }, [bookCarData]);
  // useEffect(() => {
  //   if (bookingvalidationResponse?.data?.success === true) {
  //     window.location = (`https://nodeapp.shrinkcom.com/kwacharides-backend/pay/displayGateWay/${totalAmount}/${1}/${0}`)

  //   }
  //   if (bookingvalidationResponse?.data?.success === false) {
  //     toast(`${bookingvalidationResponse?.data?.message}`)
  //   }

  // }, [bookingvalidationResponse]);

  const carBookingHandler = async (type) => {
    const pickupDate = new Date(dayjs(bookingInfo?.pickUp));
    const returnDate = new Date(dayjs(bookingInfo?.dropOff));
    const currentDate = new Date();
    let newErrMsg = {};
    if (pickupDate < currentDate.setSeconds(0, 0)) {
      newErrMsg = {
        ...newErrMsg,
        pickupDateErrMsg: "Pickup date & time must be in the future.",
      };
    }
    if (returnDate <= pickupDate) {
      newErrMsg = {
        ...newErrMsg,
        returnDateErrMsg: "Return date must be after the pickup date.",
      };
    }
    setErrMsg(newErrMsg);
    if (Object.keys(newErrMsg).length) {
      return;
    }
    const checkingResp = await dispatch(
      checkBookingValidation({
        userId: userDetail?.data?._id,
        carId: carId,
        pickUpDateandTime: bookingInfo?.pickUp,
        returnDateandTime: bookingInfo?.dropOff,
      })
    );

    if (checkingResp?.payload?.data?.success === false) {
      toast(`${checkingResp?.payload?.data?.message}`);
    }
    if (checkingResp?.payload?.data?.success === true) {
      // window.location = (`https://nodeapp.shrinkcom.com/kwacharides-backend/pay/displayGateWay/${totalAmount}/${1}/${0}`)
      const data = {
        amount: totalAmount,
        type: 1,
        device: 0,
        userId: userDetail?.data?._id,
      };
      if (type === "LENCO") {
        // const formData = new FormData();
        // formData.append("userId", userDetail?.data?._id);
        // formData.append("carId", carId);
        // formData.append("pickUpDateandTime", dayjs(bookingInfo?.pickUp).format('YYYY/MM/DD HH:mm:ss') );
        // formData.append("returnDateandTime", dayjs( bookingInfo?.dropOff).format('YYYY/MM/DD HH:mm:ss'));

        // // formData.append("bookWithDriver", checked);
        // // formData.append("driverRent", rent?.driverRent);

        // formData.append("noOfBookingDays", differenceInDays);
        // formData.append("amount", rent?.carRent);
        // formData.append("totalAmount", totalAmount);

        // formData.append(
        //   "booking_for_someone_else ",bookingInfo?.userToggle
        //   // base64Data.licenceFront ? base64Data.licenceFront : document.licence
        // );
        // if(bookingInfo?.userToggle)
        // {
        //   formData.append("name", personalDetailsData?.name);
        //   formData.append("email", personalDetailsData?.emailId);
        //   // formData.append("phone", personalDetailsData?.phone);
        //   formData.append("phone", personalDetailsData?.phoneNumber);
        //   formData.append("country_code", personalDetailsData?.countryCode);
        //   formData.append("address", personalDetailsData?.address);
        //   // formData.append(
        //   //   "identityFront",
        //   //   base64Data.idFront ? base64Data.idFront : document.idFront
        //   // );
        //   // formData.append(
        //   //   "drivingLicenseFront",
        //   //   base64Data.licenceFront ? base64Data.licenceFront : document.licence
        //   // );
        //   formData.append(
        //     "user_identity_front",
        //     document.idFront
        //   );
        //   formData.append(
        //     "user_identity_back",
        //     document.licence
        //   );
        // }
        const payload = {
          userId: userDetail?.data?._id,
          carId: carId,
          pickUpDateandTime: dayjs(bookingInfo?.pickUp).format(
            "YYYY/MM/DD HH:mm:ss"
          ),
          returnDateandTime: dayjs(bookingInfo?.dropOff).format(
            "YYYY/MM/DD HH:mm:ss"
          ),
          noOfBookingDays: differenceInDays,
          amount: rent?.carRent,
          totalAmount: totalAmount,
          booking_for_someone_else: bookingInfo?.userToggle || false,
        };

        if (bookingInfo?.userToggle) {
          payload.name = personalDetailsData?.name.trim();
          payload.email = personalDetailsData?.emailId.trim();
          payload.phone = personalDetailsData?.phoneNumber.trim();
          payload.country_code ="+"+personalDetailsData?.countryCode.trim();
          payload.address = personalDetailsData?.address;
          payload.user_identity_front = document.idFront;
          payload.user_identity_back = document.licence;
        }
        payload.paymentStatus = "Completed";
        // LENCO PAYMENT API

        const nameParts = personalDetailsData?.name?.trim().split(" ");

        // Check if name has at least two parts
        const firstName = nameParts[0] || ""; // First part is the first name
        const lastName =
          nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
        const email = personalDetailsData?.emailId;

        // BYPASS PAYMENT CODE
        // formData.append("paymentStatus", "Completed");
        
        // payload.paymentStatus = "Completed";
        // setIsSubmiited(true);
        // dispatch(bookCar(payload)).then((resp) => {
        //   if (resp?.payload?.data?.success) {
        //     toast.success(resp?.payload?.data?.message);

        //     Swal.fire({
        //       title: "Booking Details",
        //       html: `
        //       <div class="container">
        //         <div class="row mb-2">
        //           <div class="col-5 text-start"><strong>User:</strong></div>
        //           <div class="col-7 text-start">${resp?.payload?.data?.data?.user?.name}</div>
        //         </div>
        //         <div class="row mb-2">
        //           <div class="col-5 text-start"><strong>Phone:</strong></div>
        //           <div class="col-7 text-start">${resp?.payload?.data?.data?.user?.phoneNumber}</div>
        //         </div>
        //         <div class="row mb-2">
        //           <div class="col-5 text-start"><strong>Pick-Up Date and Time:</strong></div>
        //           <div class="col-7 text-start">${resp?.payload?.data?.data?.booking?.pickUpDateandTime}</div>
        //         </div>
        //         <div class="row mb-2">
        //           <div class="col-5 text-start"><strong>Return Date and Time:</strong></div>
        //           <div class="col-7 text-start">${resp?.payload?.data?.data?.booking?.returnDateandTime}</div>
        //         </div>
        //         <div class="row mb-2">
        //           <div class="col-5 text-start"><strong>Payment Status:</strong></div>
        //           <div class="col-7 text-start">${resp?.payload?.data?.data?.booking?.paymentStatus}</div>
        //         </div>
        //       </div>
        //     `,
        //       icon: "success",
        //       confirmButtonText: "OK",
        //       willClose: () => {
        //         dispatch(cleanBookingData());
        //         navigate("/mybooking");
        //       },
        //     });
        //     // setTimeout(() => {
        //     //   navigate("/mybooking");
        //     // }, 1500);
        //   } else {
        //     toast.error(resp?.payload?.data?.message);
        //   }
        //   let msg = resp?.payload?.response?.data?.errors[0];
        //   if (msg) {
        //     toast.error(msg?.msg);
        //   }
        // });
        console.log("email", personalDetailsData?.emailId,authData?.data?.emailId)

        // 26-10-24 code for lenco
        window?.LencoPay?.getPaid({
          key: process.env.REACT_APP_LENCO_PUBLIC_KEY, // Replace with your actual Lenco public key
          reference: "ref-" + Date.now(), // Generate a unique reference
          email: personalDetailsData?.emailId
            ? personalDetailsData?.emailId
            : authData?.data?.emailId, // Customer's email address
          // email: personalDetailsData.email, // Customer's email address
          amount: totalAmount.toFixed(2), // Amount to be paid (in ZMW)
          // amount: 20.00, // Amount to be paid (in ZMW)
          currency: "ZMW", // Currency for the transaction
          channels: ["card", "mobile-money"], // Payment channels
          customer: {
            firstName: firstName, // Customer's first name
            lastName: lastName, // Customer's last name
            phone: personalDetailsData?.phoneNumber || "", // Customer's phone number
          },
          onSuccess: (response) => {
            // formData.append("paymentStatus", "Completed");
            // Callback when payment is completed successfully
            const reference = response.reference;
            payload.paymentStatus = "Completed";
            dispatch(bookCar(payload)).then((resp) => {
              if (resp?.payload?.data?.success) {
                toast.success(resp?.payload?.data?.message);

                Swal.fire({
                  title: "Booking Details",
                  html: `
                  <div class="container">
                    <div class="row mb-2">
                      <div class="col-5 text-start"><strong>User:</strong></div>
                      <div class="col-7 text-start">${resp?.payload?.data?.data?.user?.name}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-5 text-start"><strong>Phone:</strong></div>
                      <div class="col-7 text-start">${resp?.payload?.data?.data?.user?.phoneNumber}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-5 text-start"><strong>Pick-Up Date and Time:</strong></div>
                      <div class="col-7 text-start">${resp?.payload?.data?.data?.booking?.pickUpDateandTime}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-5 text-start"><strong>Return Date and Time:</strong></div>
                      <div class="col-7 text-start">${resp?.payload?.data?.data?.booking?.returnDateandTime}</div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-5 text-start"><strong>Payment Status:</strong></div>
                      <div class="col-7 text-start">${resp?.payload?.data?.data?.booking?.paymentStatus}</div>
                    </div>
                  </div>
                `,
                  icon: "success",
                  confirmButtonText: "OK",
                  willClose: () => {
                    dispatch(cleanBookingData());
                    navigate("/mybooking");
                  },
                });
                // setTimeout(() => {
                //   navigate("/mybooking");
                // }, 1500);
              } else {
                toast.error(resp?.payload?.data?.message);
              }
              let msg = resp?.payload?.response?.data?.errors[0];
              if (msg) {
                toast.error(msg?.msg);
              }
            });
            setIsSubmiited(false);
           
            //     setIsSubmiited(true);
            // dispatch(bookCar(formData)).then((resp) => {
            //   console.log("resp", resp?.payload);
            //   if(resp?.payload?.data?.success)
            //   {
            //     toast.success(resp?.payload?.data?.message)
            //   }
            //   let msg = resp?.payload?.response?.data?.errors[0];
            //   if (msg) {
            //     toast.error(msg?.msg);
            //   }else{
            //     setTimeout(() => {
            //       navigate('/mybooking');
            //     }, 2000);
            //   }
            // });
            // Here you can make an AJAX call to your server to verify the payment
          },
          onClose: () => {
         

            Swal.fire({
              title: "Payment Cancelled",
              text: "Your payment has been cancelled.",
              icon: "error",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn btn-img btn-primary", // Add custom classes for the button
              },
            });
            setIsSubmiited(false);
          },
          onConfirmationPending: (response) => {
            // alert(
            //   "Your purchase will be completed when the payment is confirmed."
            // );
            setIsSubmiited(false);
            navigate(`/verify_payment/${response?.reference}`, {
              state: { response },
            });
          },
        });

        // const recipients = await fetchTransferRecipients();
        // console.log(recipients?.data[0]?.id,"recipients 100")
        //     if(recipients?.status)
        //     {
        //       console.log(recipients.data,"details fetched success 3333")
        //       recipients?.data
        //       try{
        //         let transaction=await axios.post("https://api.lenco.co/access/v2/transfers/bank-account",{

        //           amount: "20.00",
        //           narration: "Testing api payment",
        //           reference: "ref-3",
        //           accountId: recipients?.data[0]?.id
        //         },
        // {
        //   headers: {
        //     'Authorization': `Bearer ${process.env.REACT_APP_LENCO_SECRET_KEY}`, // Authorization header
        //   },
        // }

        //       )
        //       console.log('transaction', transaction)
        //       }catch(error){
        //         console.log(error)
        //       }

        //      if (typeof LencoPay === 'undefined') {
        //   alert('LencoPay script not loaded');
        //   return;
        // }

        //     }
        //     else{
        //       console.log("details fetched failed.")
        //     }
        // console.log(recipients?.data,999999)
      } else {
        axios
          .post(`${baseURL}/pay/paynow`, data)
          .then((response) => {
            window.location = response?.data?.sessionUrl;
          })
          .catch((error) => {
            console.error("Error fetching contact data:", error);
          });
        setIsSubmiited(false);
      }
    }

    // window.open(`${baseURL}/pay/displayGateWay/${totalAmount}`,'self')

    // const formData = new FormData();
    // formData.append("userId", userDetail?.data?._id);
    // formData.append("carId", carId);
    // formData.append("pickUpDateandTime", bookingInfo?.pickUp);
    // formData.append("returnDateandTime", bookingInfo?.dropOff);
    // formData.append("name", personalDetailsData?.name);
    // formData.append("email", personalDetailsData?.emailId);
    // formData.append("phone", personalDetailsData?.phone);
    // formData.append("address", personalDetailsData?.address);
    // formData.append("bookWithDriver", checked);
    // formData.append("driverRent", rent?.driverRent);
    // formData.append("paymentStatus", "Pending");
    // formData.append("noOfBookingDays", differenceInDays);
    // formData.append("amount", rent?.carRent);
    // formData.append("totalAmount", totalAmount);
    // formData.append(
    //   "identityFront",
    //   base64Data.idFront ? base64Data.idFront : document.idFront
    // );
    // formData.append(
    //   "drivingLicenseFront",
    //   base64Data.licenceFront ? base64Data.licenceFront : document.licence
    // );
    // if (formData) {
    //   setIsSubmiited(true);
    //   dispatch(bookCar(formData));
    //   setTimeout(() => {
    //     navigate('/mybooking');
    //   }, 2000);
    // }
  };

  // function dataURItoBlob(dataURI) {
  //     // convert base64/URLEncoded data component to raw binary data held in a string
  //     var byteString;
  //     if (dataURI.split(',')[0].indexOf('base64') >= 0)
  //         byteString = atob(dataURI.split(',')[1]);
  //     else
  //         byteString = unescape(dataURI.split(',')[1]);

  //     // separate out the mime component
  //     var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  //     // write the bytes of the string to a typed array
  //     var ia = new Uint8Array(byteString.length);
  //     for (var i = 0; i < byteString.length; i++) {
  //         ia[i] = byteString.charCodeAt(i);
  //     }

  //     return new Blob([ia], { type: mimeString });
  // }

  // useEffect(() => {
  //     function base64toFile(base64String, filename) {
  //         const arr = base64String.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);

  //         if (arr === null || arr.length !== 3) {
  //             // If the string is not a data URI, assume it contains only the Base64-encoded data
  //             const mime = 'application/octet-stream';
  //             return new File([base64String], filename, { type: mime });
  //         }

  //         const mime = arr[1];
  //         const bstr = atob(arr[2]);
  //         let n = bstr.length;
  //         const u8arr = new Uint8Array(n);
  //         while (n--) {
  //             u8arr[n] = bstr.charCodeAt(n);
  //         }
  //         return new File([u8arr], filename, { type: mime });
  //     }
  //     const filename = 'image.png';

  //     if (document?.idFront) {

  //     }

  // }, [])

  function base64StringToSyntheticFile(
    base64String,
    fileName = "image.png",
    fileType = "image/png"
  ) {
    if (base64String) {
      if (base64String.includes("base64")) {
        // Split the base64 string by comma to separate metadata from data
        const parts = base64String.split(",");
        // Extract the metadata part which contains the data type and base64 prefix
        const metadata = parts[0];
        // Split the metadata part by semicolon to separate data type and parameters
        const metadataParts = metadata.split(";");
        // Extract the data type which contains the MIME type and encoding
        const dataType = metadataParts[0];
        // Extract the file extension from the data type
        const extension = dataType.split("/")[1];

        fileType = dataType;
        fileName = `image.${extension}`;
        // Check if the base64 string contains a data URI prefix
        let str = base64String.substr(base64String.indexOf(",") + 1);
        // Log the base64 string before decoding

        // Convert base64 string to Blob
        const byteCharacters = atob(str);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: fileType });

        // Create synthetic file object
        const syntheticFile = new File([blob], fileName, {
          type: fileType,
        });

        return syntheticFile;
      } else {
        return base64String;
      }
    }
  }

  // const handleInput = (e) => {
  //     setInfo(e.target.value)

  // }

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  const fetchTransferRecipients = async () => {
    try {
      let res = await axios.get(
        "https://api.lenco.co/access/v2/transfer-recipients", // URL of the API
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_LENCO_SECRET_KEY}`, // Authorization header
          },
        }
      );
      console.log(res.data, "lenco resp"); // Log the response data
      return res.data; // Return response data if needed
    } catch (error) {
      setIsSubmiited(false);
      console.error(
        "Error fetching transfer recipients:",
        error.response || error.message
      );
    } finally {
      setIsSubmiited(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="container-fluid container-lg pt-3 ps-3 pe-3 pb-6">
      <div className="d-flex flex-row fs-1 accentColor align-items-center mt-2 mb-4">
        <span className="lh-0">
          <MdDoubleArrow />
        </span>
        <span className="font">Booking Summary</span>
      </div>
      {/* <h2 className='font accentColor mb-4' ><MdDoubleArrow />Booking Summary</h2> */}
      <div className="row g-sm-0 g-md-3">
        <div className="col-md-7">
          {/* <div className="card card-shadow border-0 m-2 position-relative" >
                        <div className='row' >
                            <h3 className="card-title ps-3 py-2 ps-4 font text-center text-md-start ">Mercedes Benz</h3>

                            <div className='col-sm-4 my-auto' >
                                <img src="https://images.pexels.com/photos/170811/pexels-photo-170811.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" className="card-img-top ps-md-2" alt="car-image" />
                            </div>
                            <div className='col-sm-8 my-auto' >
                                <div className='row' >
                                    <div className='col-md-12' >
                                        <div className='d-flex py-5 py-md-3 flex-row justify-content-evenly align-items-center' >
                                            <div className='' >
                                                <p className='secondaryColor seater' ><MdPersonOutline className='seater-icon' />2 seater</p>
                                                <p className='secondaryColor seater' ><span  >Max Power</span> : 320 HP</p>
                                                <p className='secondaryColor seater' ><span  >Top Speed</span> : 220 km/h</p>
                                                <p className='secondaryColor seater' ><span  >Motor</span> : 2500cc</p>
                                            </div>
                                            <div className='text-center d-flex flex-column gap-3' >
                                                <p className='car-price' >
                                                    $220/day
                                                </p>
                                                <button type="button" className="btn img-btn primaryColor">Remove</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div> */}

          <div className="">
            <div className="row">
              <div className="d-flex align-items-center gap-3 pb-3">
                {/* <h4 className="secondaryColor fw-normal">McLaren 750s</h4> */}
                <h4 className="secondaryColor fw-normal text-capitalize ">
                  {pageData?.maker?.carMake}-{pageData?.model?.carModel}
                  <span className="secondaryColor fw-normal text-capitalize">
                    {" "}
                    ({pageData?.carCategoryId?.categoryName})
                  </span>
                </h4>
                {checked ? (
                  <p className=" rounded-5 px-2 red-badge">
                    <RxDotFilled className=" my-auto" />
                    With Driver
                  </p>
                ) : null}
              </div>
              <div className="col-lg-5 col-md-6 my-auto">
                <div className="d-flex align-items-center justify-content-between "></div>
                {/* <img
                  src="https://t3.ftcdn.net/jpg/01/23/52/24/240_F_123522493_qV0XZfz5gH3zeWFq1YiNCwpDT8HPfvZL.jpg"
                  className="summary-img"
                  alt="car-img"
                /> */}
                <img
                  src={`${baseURL}${pageData?.frontImage}`}
                  className="summary-img"
                  alt="car-img"
                />
              </div>

              <div className="col-lg-7 col-md-6 my-auto py-3 py-md-0">
                <div className="d-flex flex-column">
                  <div className="order-1 order-sm-0">
                    <h5 className="mb-1">K{pageData?.pricePerDay}/day</h5>
                    <div className="mb-2">
                      <Rating
                        name="avg Rating"
                        value={+pageData?.averageRating} // Assuming pageData contains the average rating
                        precision={0.5} // Set precision to 0.5 to allow half-star values
                        readOnly
                        // size="large" // Set the size of the stars
                        size="24px"
                      />
                    </div>
                    <div className="d-flex flex-row flex-wrap max_w_275 row-gap-2">
                      {/* <div className="d-flex flex-column ">
                        <p className="fs14">
                          <IoPerson className="feature-icon " />5 Seater
                        </p>
                        <p className="fs14">
                          <LuAirVent className="feature-icon " />
                          Air Conditioning
                        </p>
                        <p className="fs14">
                          <FaMusic className="feature-icon " />
                          Music
                        </p>
                      </div>
                      <div className="d-flex flex-column">
                        <p className="fs14">
                          <HiColorSwatch className="feature-icon " />
                          Color
                        </p>
                        <p className="fs14">
                          <BsFillFuelPumpFill className="feature-icon " />
                          Full tank
                        </p>
                        <p className="fs14">
                          <GrManual className="feature-icon " />
                          Manual
                        </p>
                      </div> */}

                      {pageData?.features?.map((ele, index) => (
                        <div key={ele?._id} className="d-flex flex-column w-50">
                          <p className="fs14 text-nowrap">
                            <i className={`${ele?.icon} feature-icon`}></i>
                            {ele?.carFeature}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="d-flex gap-2 align-items-center mt-1 mt-sm-2 order-0 order-md-1 pb-2 pb-sm-0">
                    <div>
                      <p className="">
                        {/* <span className="fs12">{pageData?.averageRating}</span> */}
                        <span className="line_height fs12">
                          {/* <GrStar /> */}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className='px-1 my-4' >

                        <h4 className='font accentColor mb-3' >Driver Details</h4>
                        <div className='d-flex flex-column flex-md-row justify-content-between' >

                            <div>

                                <div className='d-flex flex-row' >
                                    <div className='w-100px d-flex justify-content-between' >
                                        <h6 className='text-dark' >Full Name</h6>
                                        <h6 className='text-dark' >:</h6>

                                    </div>
                                    <p className='text-secondary fs14 ps-3' >Drivers Name</p>
                                </div>

                                <div className='d-flex flex-row' >
                                    <div className='w-100px d-flex justify-content-between' >
                                        <h6 className='text-dark' >Age</h6>
                                        <h6 className='text-dark' >:</h6>
                                    </div>
                                    <p className='text-secondary fs14 ps-3 ' >44</p>
                                </div>
                            </div>
                            <div >

                                <div className='d-flex flex-row' >
                                    <div className='w-100px d-flex justify-content-between' >
                                        <h6 className='text-dark' >Email</h6>
                                        <h6 className='text-dark' >:</h6>
                                    </div>
                                    <p className='text-secondary fs14 ps-3' >test@gmail.com</p>
                                </div>

                                <div className='d-flex flex-row' >
                                    <div className='w-100px d-flex justify-content-between' >
                                        <h6 className='text-dark' >Phone </h6>
                                        <h6 className='text-dark' >:</h6>
                                    </div>
                                    <p className='text-secondary fs14 ps-3' >+911234567895</p>
                                </div>
                            </div>
                        </div>



                    </div> */}

          <div className="pb-3 pb-md-5 mt-5">
            <div className="d-flex align-items-center">
              {/* <h6 className="text-secondary m-0 ">With Driver</h6>
              <Tooltip>
                <Switch
                  checked={checked}
                  // onChange={pageData?.withDriver ? handleChange : undefined}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Tooltip> */}
            </div>
            <div className="wizard">
              <div className="v-line"></div>
              <div className="step-dot">
                <div>
                  <h6 className="accentColor">Pick-up</h6>
                  <div className="mt-2">
                    {/* {edit ?
                                            <div className='my-2' >
                                                <p className='fs14 secondaryColor pb-2' >Address</p>
                                                <TextInput
                                                    type="text"
                                                    id="pickAddress"
                                                    value={info.pickAddress}
                                                    onChange={handleInput}
                                                    size="small"
                                                    name="pickAddress"
                                                // error={errmsg?.nameErrMsg}
                                                // helperText={errmsg?.nameErrMsg}
                                                />
                                            </div>
                                            :
                                            <p className='text-secondary fs14' >{info.pickAddress}</p>

                                        } */}
                    {edit ? (
                      <div className="mb-2 w-75">
                        <p className="fs14 secondaryColor">Time & Date</p>
                        <TimeandDate
                          format="DD/MM/YYYY hh:mm a"
                          value={dayjs(info?.PickupDate)}
                          onChange={(newValue) => {
                            const date = new Date(newValue.$d);
                            setInfo((prevInfo) => ({
                              ...prevInfo,
                              PickupDate: date,
                            }));
                          }}
                          name="PickupDate"
                          id="PickupDate"
                        />
                        <FormHelperText className="text-danger">
                          {errMsg?.pickupDateErrMsg}
                        </FormHelperText>
                      </div>
                    ) : (
                      <>
                        <p className="text-secondary fs14">
                          {dayjs(info.PickupDate).format("DD/MM/YYYY hh:mm a")}
                        </p>
                        <FormHelperText className="text-danger">
                          {errMsg?.pickupDateErrMsg}
                        </FormHelperText>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="step-dot">
                <div>
                  <h6 className="accentColor">Drop-off</h6>
                  <div className="mt-2">
                    {/* {edit ?
                                            <div className='my-2' >
                                                <p className='fs14 secondaryColor pb-2' >Address</p>

                                                <TextInput
                                                    type="text"
                                                    id="returnAddress"
                                                    value={info.returnAddress}
                                                    onChange={handleInput}
                                                    size="small"
                                                    name="returnAddress"
                                                // error={errmsg?.nameErrMsg}
                                                // helperText={errmsg?.nameErrMsg}
                                                />
                                            </div>
                                            :
                                            <p className='text-secondary fs14' >{info.pickAddress}</p>


                                        } */}

                    {edit ? (
                      <div className="mb-2 w-75">
                        <p className="fs14 secondaryColor">Time & Date</p>

                        <TimeandDate
                          blockFuture={info?.PickupDate}
                          format="DD/MM/YYYY hh:mm a"
                          value={dayjs(info?.returnDate)}
                          onChange={(newValue) => {
                            const date = new Date(newValue.$d);
                            setInfo((prevInfo) => ({
                              ...prevInfo,
                              returnDate: date,
                            }));
                          }}
                          name="returnDate"
                          id="returnDate"
                        />
                        <FormHelperText className="text-danger">
                          {errMsg?.returnDateErrMsg}
                        </FormHelperText>
                      </div>
                    ) : (
                      <>
                        <p className="text-secondary fs14">
                          {dayjs(info.returnDate).format("DD/MM/YYYY hh:mm a")}
                        </p>
                        <FormHelperText className="text-danger">
                          {errMsg?.returnDateErrMsg}
                        </FormHelperText>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <h6 onClick={handleEdit} className="ps-2 mt-2 pointor">
              {" "}
              <span data-tooltip-id="edit">
                <BiEdit className="accentColor edit-icon me-2 pointor" />
              </span>
              {edit ? "Save" : "Edit Info"}
            </h6>
          </div>
        </div>

        <div className="col-md-5">
          <div className="ps-lg-3">
            <div className="card">
              <div className="card-header">
                <h3 className="font accentColor">Payment Detail</h3>
              </div>
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center my-2">
                  <p>Car rent Charges</p>
                  <h6 className="font fs18 fw-semibold">
                    K{rent?.carRent}/day
                  </h6>
                </div>
                {pageData?.withDriver ? (
                  <div className="d-flex  justify-content-between align-items-center my-2">
                    <p>Driver Charges</p>
                    <h6 className="font fs18 fw-semibold">
                      K{checked ? rent?.driverRent : 0}/day
                    </h6>
                  </div>
                ) : null}

                <div className="d-flex justify-content-between align-items-center my-2">
                  <p>Days</p>
                  <h6 className="font fs18 fw-semibold">{differenceInDays}</h6>
                </div>

                <hr />
                <dl className="row mb-0">
                  <div className="d-flex justify-content-between align-items-center">
                    <h6>Total </h6>
                    <p className="font fs18 fw-semibold">K{totalAmount}</p>
                  </div>
                </dl>
              </div>
            </div>
            {/* <div className='mt-2 mb-5' >

                            <Checkbox
                                checked={checked}
                                onChange={handleChange}
                                id='agree-checkbox'
                            />
                            <label htmlFor='agree-checkbox' >I agree with <Link to='/' className='accentColor' >Terms and conditions</Link></label>
                        </div> */}
            {/* <Link to="/payment" ><button onClick={scrollToTop} type="button" className="btn  w-100 img-btn primaryColor mt-5">Confirm</button></Link> */}
            {/* <div className="d-flex gap-2 ">
          <button
              onClick={() => carBookingHandler()}
              type="button"
              className="btn img-btn primaryColor mt-5"
            >
              Confirm
            </button>                
                <button    onClick={() => carBookingHandler("LENCO")}
              type="button"
              className="btn  img-btn primaryColor mt-5">
                  Lenco pay
                </button>
            </div> */}
            <div className="row row-gap-2 mt-5">
              <button
                onClick={() => carBookingHandler("LENCO")}
                type="button"
                className="btn img-btn primaryColor w-100"
              >
                Confirm
              </button>
              {/* <div className="col-12 col-sm-6">
                <button
                  onClick={() => carBookingHandler()}
                  type="button"
                  className="btn img-btn primaryColor w-100"
                >
                  Stripe Pay
                </button>
              </div>
              <div className="col-12 col-sm-6">
                <button
                  onClick={() => carBookingHandler("LENCO")}
                  type="button"
                  className="btn img-btn primaryColor w-100"
                >
                 Confirm
                </button>
              </div> */}
            </div>

            {/* <button
              onClick={() => carBookingHandler("DPO")}
              type="button"
              className="btn  w-100 img-btn primaryColor mt-5"
            >
              Pay with DPO
            </button> */}
          </div>
          {/* {bookCarData ? <span className='m-3'>{isSubmitted && bookCarData?.data?.message}</span> : null} */}
        </div>
      </div>
    </div>
  );
};

export default Index;

// import React, { useState, useEffect } from 'react'
// import car1 from '../../assets/assets/images/home_images/home_grid1.png'
// import TextInput from '../fields/TextInput';
// import { BiEdit } from "react-icons/bi";
// import TimeandDate from '../fields/TimeandDate';
// import { Link } from 'react-router-dom';
// import { MdDoubleArrow, MdPerson, MdPersonOutline } from 'react-icons/md';
// import { Tooltip as ReactTooltip } from "react-tooltip";
// import { Checkbox, FormControlLabel, Switch, TextField, Tooltip } from '@mui/material';
// import dayjs from 'dayjs';
// import { FaMusic, FaTrashAlt } from "react-icons/fa";
// import { PiDotOutlineFill } from "react-icons/pi";
// import { RxDotFilled } from "react-icons/rx";
// import { GrStar } from "react-icons/gr";
// import { TbAirConditioning, TbManualGearbox } from 'react-icons/tb';
// import { HiColorSwatch, HiTrash } from 'react-icons/hi';
// import { BsFillFuelPumpFill } from 'react-icons/bs';
// import { LuAirVent } from 'react-icons/lu';
// import { GrManual } from "react-icons/gr";
// import { IoPerson } from "react-icons/io5";
// import { useDispatch, useSelector } from 'react-redux';
// import { bookCar, cleanBookingData, setBookingData, setWithDriver } from '../../redux/Slice/bookingSlice';
// import { toast } from 'react-toastify';

// const Index = () => {
//   const dispatch = useDispatch();
//   const bookingInfo = useSelector((state) => state?.booking?.bookingInfo)
//   const personalDetailsData = useSelector((state) => state?.booking?.personalDetailsData)
//   const bookCarStatus = useSelector((state) => state?.booking?.bookCarStatus)
//   const document = useSelector((state) => state?.booking?.documentsData);
//   const bookingImageObj = useSelector((state) => state?.booking?.bookingImageObj);
//   const carId = useSelector((state) => state?.booking?.carId);
//   const withDriver = useSelector((state) => state?.booking?.withDriver);
//   const userDetail = useSelector((state) => state?.auth?.userDetail)
//   const bookCarData = useSelector((state) => state?.booking?.bookCarData);
//   const [edit, setEdit] = useState(false)
//   const [checked, setChecked] = useState(true);
//   const [base64Data, setBase64Data] = useState({});
//   const [isSubmitted, setIsSubmiited] = useState(false);

//   const [info, setInfo] = useState({
//     // pickAddress: "264 Royal Ln. Mesa, New Jersey 45453",
//     // returnAddress: "264 Royal Ln. Mesa, New Jersey 45453",
//     // PickupDate: "11/12/2024 02:34 am",
//     // returnDate: "12/12/2024 02:34 am",
//     PickupDate: bookingInfo?.pickUp,
//     returnDate: bookingInfo?.dropOff,
//   })
//   const calculateDifference = (start, end) => {

//     const differenceInMilliseconds = Math.abs(end - start);
//     return Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));
//   }

//   const [differenceInDays, setDifferenceInDays] = useState(null);

//   useEffect(() => {
//     const daysDifference = calculateDifference(dayjs(bookingInfo?.pickUp), dayjs(bookingInfo?.dropOff));
//     setDifferenceInDays(daysDifference);
//   }, [info]);

//   useEffect(() => {
//     dispatch(setBookingData({
//       pickUp: info.PickupDate,
//       dropOff: info.returnDate,
//     }));
//   }, [info])

//   const handleChange = (event) => {
//     setChecked(event.target.checked);
//     dispatch(setWithDriver(event.target.checked));
//   };

//   const handleEdit = () => {
//     setEdit(!edit)
//   }

//   useEffect(() => {
//     setBase64Data({
//       idFront: base64StringToSyntheticFile(document?.idFront),
//       licenceFront: base64StringToSyntheticFile(document?.licence)
//     })
//   }, [document])
//   useEffect(() => {
//     if (bookCarData?.data?.success === true) {
//       dispatch(cleanBookingData());
//     }
//   }, [bookCarData])

//   const notify = () => toast(`${bookCarData?.data?.message}`);
//   useEffect(() => {
//     if (bookCarStatus === "success" && bookCarData.status === 200) {
//       notify()
//     }
//   }, [bookCarStatus, bookCarData])

//   const carBookingHandler = () => {

//     const formData = new FormData();

//     formData.append("userId", userDetail?.data?._id);
//     formData.append("carId", carId);
//     formData.append("pickUpDateandTime", bookingInfo?.pickUp);
//     formData.append("returnDateandTime", bookingInfo?.dropOff);
//     formData.append("name", personalDetailsData?.name);
//     formData.append("email", personalDetailsData?.emailId);
//     formData.append("phone", personalDetailsData?.phone);
//     formData.append("address", personalDetailsData?.address);
//     formData.append("bookWithDriver", checked);
//     formData.append("driverRent", 3500);
//     formData.append("paymentStatus", 'Pending');
//     formData.append("noOfBookingDays", differenceInDays);
//     formData.append("amount", 4000);
//     formData.append("totalAmount", 1);
//     // formData.append("identityFront", bookingImageObj.idFront);
//     // formData.append("drivingLicenseFront", bookingImageObj.licenceFront);
//     formData.append("identityFront", base64Data.idFront ? base64Data.idFront : document.idFront);
//     formData.append("drivingLicenseFront", base64Data.licenceFront ? base64Data.licenceFront : document.licence);
//     // dispatch(bookCar({
//     //     userId: userDetail?.data?._id,
//     //     carId: carId,
//     //     pickUpDateandTime: bookingInfo?.pickUp,
//     //     returnDateandTime: bookingInfo?.dropOff,
//     //     // amount: 40000,
//     //     // name: 'abvd',
//     //     // email: "abvd@gmail.com",
//     //     // phone: "+91 123-456",
//     //     // address: "indore",
//     //     name: personalDetailsData?.name,
//     //     email: personalDetailsData?.emailId,
//     //     phone: personalDetailsData?.phone,
//     //     address: personalDetailsData?.address,
//     //     bookWithDriver: withDriver,
//     //     driverRent: 3500,
//     //     paymentStatus: 'Pending',
//     //     noOfBookingDays: 2,
//     //     totalAmount: 1,
//     //     identityFront: bookingImageObj.idFront,
//     //     drivingLicenseFront: bookingImageObj.licenceFront
//     // }))
//     if (formData) {
//       setIsSubmiited(true)
//       dispatch(bookCar(formData))
//     }
//     // const notify = () => toast(`${bookCarData?.data?.message}`);
//     // if (bookCarData?.data?.sucess === true) {
//     //     notify()
//     // }
//   }

//   // function dataURItoBlob(dataURI) {
//   //     // convert base64/URLEncoded data component to raw binary data held in a string
//   //     var byteString;
//   //     if (dataURI.split(',')[0].indexOf('base64') >= 0)
//   //         byteString = atob(dataURI.split(',')[1]);
//   //     else
//   //         byteString = unescape(dataURI.split(',')[1]);

//   //     // separate out the mime component
//   //     var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

//   //     // write the bytes of the string to a typed array
//   //     var ia = new Uint8Array(byteString.length);
//   //     for (var i = 0; i < byteString.length; i++) {
//   //         ia[i] = byteString.charCodeAt(i);
//   //     }

//   //     return new Blob([ia], { type: mimeString });
//   // }

//   // useEffect(() => {
//   //     function base64toFile(base64String, filename) {
//   //         const arr = base64String.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);

//   //         if (arr === null || arr.length !== 3) {
//   //             // If the string is not a data URI, assume it contains only the Base64-encoded data
//   //             const mime = 'application/octet-stream';
//   //             return new File([base64String], filename, { type: mime });
//   //         }

//   //         const mime = arr[1];
//   //         const bstr = atob(arr[2]);
//   //         let n = bstr.length;
//   //         const u8arr = new Uint8Array(n);
//   //         while (n--) {
//   //             u8arr[n] = bstr.charCodeAt(n);
//   //         }
//   //         return new File([u8arr], filename, { type: mime });
//   //     }
//   //     const filename = 'image.png';

//   //     if (document?.idFront) {

//   //     }

//   // }, [])

//   function base64StringToSyntheticFile(base64String, fileName = 'image.png', fileType = 'image/png') {
//     if (base64String.includes("base64")) {

//       // Split the base64 string by comma to separate metadata from data
//       const parts = base64String.split(',');
//       // Extract the metadata part which contains the data type and base64 prefix
//       const metadata = parts[0];
//       // Split the metadata part by semicolon to separate data type and parameters
//       const metadataParts = metadata.split(';');
//       // Extract the data type which contains the MIME type and encoding
//       const dataType = metadataParts[0];
//       // Extract the file extension from the data type
//       const extension = dataType.split('/')[1];

//       fileType = dataType;
//       fileName = `image.${extension}`;
//       // Check if the base64 string contains a data URI prefix
//       let str = base64String.substr(base64String.indexOf(",") + 1);
//       // Log the base64 string before decoding

//       // Convert base64 string to Blob
//       const byteCharacters = atob(str);
//       const byteNumbers = new Array(byteCharacters.length);
//       for (let i = 0; i < byteCharacters.length; i++) {
//         byteNumbers[i] = byteCharacters.charCodeAt(i);
//       }
//       const byteArray = new Uint8Array(byteNumbers);
//       const blob = new Blob([byteArray], { type: fileType });

//       // Create synthetic file object
//       const syntheticFile = new File([blob], fileName, {
//         type: fileType,
//       });

//       return syntheticFile;
//     }
//     else {
//       return base64String;
//     }
//   };

//   // const handleInput = (e) => {
//   //     setInfo(e.target.value)

//   // }

//   const handleInput = (e) => {
//     const { name, value } = e.target;
//     setInfo(prevInfo => ({
//       ...prevInfo,
//       [name]: value
//     }));
//   };

//   const scrollToTop = () => {
//     window.scrollTo(0, 0)
//   }

//   return (
//     <div className='container-fluid container-lg pt-3 ps-3 pe-3 pb-6' >
//       <div className='d-flex flex-row fs-1 accentColor align-items-center mt-2 mb-4' >
//         <span className='lh-0' ><MdDoubleArrow /></span><span className='font' >Booking Summary</span>

//       </div>
//       {/* <h2 className='font accentColor mb-4' ><MdDoubleArrow />Booking Summary</h2> */}
//       <div className='row g-sm-0 g-md-3' >
//         <div className='col-md-7' >
//           {/* <div className="card card-shadow border-0 m-2 position-relative" >
//                         <div className='row' >
//                             <h3 className="card-title ps-3 py-2 ps-4 font text-center text-md-start ">Mercedes Benz</h3>

//                             <div className='col-sm-4 my-auto' >
//                                 <img src="https://images.pexels.com/photos/170811/pexels-photo-170811.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" className="card-img-top ps-md-2" alt="car-image" />
//                             </div>
//                             <div className='col-sm-8 my-auto' >
//                                 <div className='row' >
//                                     <div className='col-md-12' >
//                                         <div className='d-flex py-5 py-md-3 flex-row justify-content-evenly align-items-center' >
//                                             <div className='' >
//                                                 <p className='secondaryColor seater' ><MdPersonOutline className='seater-icon' />2 seater</p>
//                                                 <p className='secondaryColor seater' ><span  >Max Power</span> : 320 HP</p>
//                                                 <p className='secondaryColor seater' ><span  >Top Speed</span> : 220 km/h</p>
//                                                 <p className='secondaryColor seater' ><span  >Motor</span> : 2500cc</p>
//                                             </div>
//                                             <div className='text-center d-flex flex-column gap-3' >
//                                                 <p className='car-price' >
//                                                     $220/day
//                                                 </p>
//                                                 <button type="button" className="btn img-btn primaryColor">Remove</button>

//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                     </div> */}

//           <div className='' >
//             <div className='row' >
//               <div className='d-flex align-items-center gap-3 pb-3' >
//                 <h4 className='secondaryColor fw-normal' >McLaren 750s</h4>
//                 {checked ? <p className=' rounded-5 px-2 red-badge' ><RxDotFilled className=' my-auto' />With Driver</p> : null}
//               </div>
//               <div className='col-md-4 my-auto' >
//                 <div className='d-flex align-items-center justify-content-between ' >

//                 </div>
//                 <img src="https://t3.ftcdn.net/jpg/01/23/52/24/240_F_123522493_qV0XZfz5gH3zeWFq1YiNCwpDT8HPfvZL.jpg" className="summary-img" alt="car-image" />
//               </div>

//               <div className='py-3 py-md-0 col-md-8 my-auto' >
//                 <div className='d-flex flex-column' >

//                   <div className='order-1 order-sm-0' >

//                     <div className='d-flex flex-row  flex-wrap gap-4 gap-md-5' >
//                       <div className='d-flex flex-column ' >
//                         <p className='fs14'><IoPerson className='feature-icon ' />5 Seater</p>
//                         <p className='fs14'><LuAirVent className='feature-icon ' />Air Conditioning</p>
//                         <p className='fs14'><FaMusic className='feature-icon ' />Music</p>
//                       </div>
//                       <div className='d-flex flex-column' >
//                         <p className='fs14'><HiColorSwatch className="feature-icon " />Color</p>
//                         <p className='fs14'><BsFillFuelPumpFill className='feature-icon ' />Full tank</p>
//                         <p className='fs14'><GrManual className='feature-icon ' />Manual</p>
//                       </div>
//                     </div>
//                   </div>

//                   <div className='d-flex gap-2 align-items-center mt-1 mt-sm-2 order-0 order-md-1 pb-2 pb-sm-0' >
//                     <div>
//                       <p className='star-rating' ><span className='fs12'>4.9</span><span className='line_height fs12'><GrStar /></span></p>
//                     </div>
//                     <h5>$200/day</h5>
//                   </div>

//                 </div>
//               </div>

//             </div>
//           </div>

//           {/* <div className='px-1 my-4' >

//                         <h4 className='font accentColor mb-3' >Driver Details</h4>
//                         <div className='d-flex flex-column flex-md-row justify-content-between' >

//                             <div>

//                                 <div className='d-flex flex-row' >
//                                     <div className='w-100px d-flex justify-content-between' >
//                                         <h6 className='text-dark' >Full Name</h6>
//                                         <h6 className='text-dark' >:</h6>

//                                     </div>
//                                     <p className='text-secondary fs14 ps-3' >Drivers Name</p>
//                                 </div>

//                                 <div className='d-flex flex-row' >
//                                     <div className='w-100px d-flex justify-content-between' >
//                                         <h6 className='text-dark' >Age</h6>
//                                         <h6 className='text-dark' >:</h6>
//                                     </div>
//                                     <p className='text-secondary fs14 ps-3 ' >44</p>
//                                 </div>
//                             </div>
//                             <div >

//                                 <div className='d-flex flex-row' >
//                                     <div className='w-100px d-flex justify-content-between' >
//                                         <h6 className='text-dark' >Email</h6>
//                                         <h6 className='text-dark' >:</h6>
//                                     </div>
//                                     <p className='text-secondary fs14 ps-3' >test@gmail.com</p>
//                                 </div>

//                                 <div className='d-flex flex-row' >
//                                     <div className='w-100px d-flex justify-content-between' >
//                                         <h6 className='text-dark' >Phone </h6>
//                                         <h6 className='text-dark' >:</h6>
//                                     </div>
//                                     <p className='text-secondary fs14 ps-3' >+911234567895</p>
//                                 </div>
//                             </div>
//                         </div>

//                     </div> */}

//           <div className='pb-3 pb-md-5 mt-5' >
//             <div className='d-flex align-items-center' >
//               <h6 className='text-secondary m-0 ' >With Driver</h6>
//               <Switch
//                 checked={checked}
//                 onChange={handleChange}
//                 inputProps={{ 'aria-label': 'controlled' }}
//               />
//             </div>
//             <div className="wizard">
//               <div className="v-line"></div>
//               <div className="step-dot">
//                 <div>
//                   <h6 className='accentColor' >Pick-up</h6>
//                   <div className='mt-2' >
//                     {/* {edit ?
//                                             <div className='my-2' >
//                                                 <p className='fs14 secondaryColor pb-2' >Address</p>
//                                                 <TextInput
//                                                     type="text"
//                                                     id="pickAddress"
//                                                     value={info.pickAddress}
//                                                     onChange={handleInput}
//                                                     size="small"
//                                                     name="pickAddress"
//                                                 // error={errmsg?.nameErrMsg}
//                                                 // helperText={errmsg?.nameErrMsg}
//                                                 />
//                                             </div>
//                                             :
//                                             <p className='text-secondary fs14' >{info.pickAddress}</p>

//                                         } */}

//                     {edit ?
//                       <div className='mb-2' >
//                         <p className='fs14 secondaryColor' >Time & Date</p>
//                         <TimeandDate
//                           format='DD/MM/YYYY hh:mm a'
//                           value={dayjs(info?.PickupDate)}
//                           onChange={(newValue) => {
//                             const date = new Date(newValue.$d)
//                             setInfo(prevInfo => ({
//                               ...prevInfo,
//                               PickupDate: date
//                             }))
//                           }} name="PickupDate"
//                           id="PickupDate"

//                         />
//                       </div>
//                       :
//                       <p className='text-secondary fs14' >{dayjs(info.PickupDate).format('DD/MM/YYYY hh:mm a')}</p>
//                     }

//                   </div>
//                 </div>
//               </div>
//               <div className="step-dot">
//                 <div>
//                   <h6 className='accentColor' >Drop-off</h6>
//                   <div className='mt-2' >
//                     {/* {edit ?
//                                             <div className='my-2' >
//                                                 <p className='fs14 secondaryColor pb-2' >Address</p>

//                                                 <TextInput
//                                                     type="text"
//                                                     id="returnAddress"
//                                                     value={info.returnAddress}
//                                                     onChange={handleInput}
//                                                     size="small"
//                                                     name="returnAddress"
//                                                 // error={errmsg?.nameErrMsg}
//                                                 // helperText={errmsg?.nameErrMsg}
//                                                 />
//                                             </div>
//                                             :
//                                             <p className='text-secondary fs14' >{info.pickAddress}</p>

//                                         } */}

//                     {edit ?
//                       <div className='mb-2' >
//                         <p className='fs14 secondaryColor' >Time & Date</p>

//                         <TimeandDate
//                           format='DD/MM/YYYY hh:mm a'
//                           value={dayjs(info?.returnDate)}
//                           onChange={(newValue) => {
//                             const date = new Date(newValue.$d)
//                             setInfo(prevInfo => ({
//                               ...prevInfo,
//                               returnDate: date
//                             }))
//                           }} name="returnDate"
//                           id="returnDate"

//                         />

//                       </div>
//                       :
//                       <p className='text-secondary fs14' >{dayjs(info.returnDate).format('DD/MM/YYYY hh:mm a')}</p>
//                     }

//                   </div>
//                 </div>
//               </div>

//             </div>
//             <h6 onClick={handleEdit} className='ps-2 mt-2 pointor' > <span data-tooltip-id="edit" ><BiEdit className='accentColor edit-icon me-2 pointor' /></span>{edit ? "Save" : "Edit Info"}</h6>
//           </div>

//         </div>

//         <div className="col-md-5">
//           <div className='ps-lg-3' >

//             <div className="card">
//               <div className="card-header">
//                 <h3 className='font accentColor' >Payment Detail</h3>
//               </div>
//               <div className="card-body">
//                 <div className='d-flex justify-content-between align-items-center my-2' ><p>Car rent Charges</p><h6 className='font fs18 fw-semibold'   >$220/day</h6></div>
//                 <div className='d-flex justify-content-between align-items-center my-2' ><p>Driver Charges</p><h6 className='font fs18 fw-semibold' >$50/day</h6></div>
//                 <div className='d-flex justify-content-between align-items-center my-2' ><p>Days</p><h6 className='font fs18 fw-semibold' >2</h6></div>

//                 <hr />
//                 <dl className="row mb-0">
//                   <div className='d-flex justify-content-between align-items-center' ><h6>Total </h6><p className='font fs18 fw-semibold' >$540</p></div>

//                 </dl>
//               </div>
//             </div>
//             {/* <div className='mt-2 mb-5' >

//                             <Checkbox
//                                 checked={checked}
//                                 onChange={handleChange}
//                                 id='agree-checkbox'
//                             />
//                             <label htmlFor='agree-checkbox' >I agree with <Link to='/' className='accentColor' >Terms and conditions</Link></label>
//                         </div> */}
//             {/* <Link to="/payment" ><button onClick={scrollToTop} type="button" className="btn  w-100 img-btn primaryColor mt-5">Confirm</button></Link> */}
//             <button onClick={() => carBookingHandler(document)} type="button" className="btn  w-100 img-btn primaryColor mt-5">Confirm</button>
//           </div>
//           {/* {bookCarData ? <span className='m-3'>{isSubmitted && bookCarData?.data?.message}</span> : null} */}
//         </div>
//       </div>
//     </div>

//   )
// }

// export default Index
